// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2BN_q","item":"PaymentsMobile_item__3wFHA","label":"PaymentsMobile_label__3Ps89","amount":"PaymentsMobile_amount__1qEgX"};